export const ELO_LEVEL_GAP = 28;
export const ELO_LEVEL_BASE = 700;
export const ELO_LEVEL_9_DAN = 2007;
export const ELO_LEVEL_8_DAN = 1930;
export const ELO_LEVEL_7_DAN = 1800;
export const ELO_LEVEL_6_DAN = 1730;
export const ELO_LEVEL_GAP_LOW = 70;
export const ELO_LOW_LEVEL_COUNT = 3;
export const VISIBLE_ELO_LEVEL_DEFAULT_FOR_USER = 644;
export const ELO_LEVEL_DEFAULT_FOR_USER = 1200;
export const FIRST_LEVEL = 0; // 30 kyu
export const LAST_KNOWN_LEVEL = 38; // 9 dan
export const FIRST_DAN_LEVEL = 30; // 1 dan
export const LAST_KNOWN_KYU_LEVEL = 29; // 1 kyu
export const RECOMMENDATIONS_GAP = 10;
export const FIRST_SINGLE_DIGIT_LEVEL = 21; // 9kyu
export const MINIMUM_LEVEL_TO_FOR_USERS = 10;
export const MINIMUM_LEVEL_TO_FOR_GUESTS = 20;
